import { FC } from 'react';
import { Form, Input, Switch } from 'antd';
import { IWorkspaceModule } from '../context/context.interface';
import WORKSPACE_MODULE_FIELD_OVERRIDES from '../../../../const/worksapce-module';

interface Props {
    item: IWorkspaceModule;
}

const ModuleFields: FC<Props> = ({ item }) => {
    const overrides = WORKSPACE_MODULE_FIELD_OVERRIDES[item.moduleKeyName] || [];
    const overrideNames = overrides.map((o) => o.name);
    const fieldsToRender = Array.from(new Set([...(item.moduleID.fields || []), ...overrideNames]));

    return (
        <>
            {fieldsToRender.map((field: string, index: number) => {
                const override = overrides.find((o) => o.name === field);
                const isBoolean = override?.type === 'boolean';
                return (
                    <Form.Item
                        key={index}
                        label={field}
                        name={field}
                        valuePropName={isBoolean ? 'checked' : undefined}
                    >
                        {isBoolean ? (
                            <Switch />
                        ) : (
                            <Input placeholder={field} value={item[field]} />
                        )}
                    </Form.Item>
                );
            })}
        </>
    );
};

export default ModuleFields;
